import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, BackendInterceptor, LocationConfigService, Order } from 'gung-standard';
import { OttoOlsenOrderNavigationService } from '../../services/otto-olsen-order-navigation.service';
import { DateUtilService } from 'gung-common';
import { JeevesOpenOrderTableListComponent } from 'gung-standard-jeeves';

@Component({
    selector: 'otto-olsen-open-order-table',
    templateUrl: './otto-olsen-open-order-table.component.html',
    styleUrls: ['./otto-olsen-open-order-table.component.scss'],
    standalone: false
})
export class OttoOlsenOpenOrderTableComponent extends JeevesOpenOrderTableListComponent {
  public orderNavigationService = inject(OttoOlsenOrderNavigationService)
  

  public getOrderIds(orders: Order[]): string[] {
    return orders.map(o => o.id);
  }
}
